"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchInputTopAttribute = exports.getMobileCssHeightVariable = void 0;
var _constants = require("../constants");
const getMobileCssHeightVariable = ({
  isTopBannerVisible,
  showSearchOnScroll
}) => {
  if (isTopBannerVisible && showSearchOnScroll) {
    return _constants.CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  if (isTopBannerVisible) {
    return _constants.CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  if (showSearchOnScroll) {
    return _constants.CSS_MOBILE_WITH_SEARCH_INPUT_HEIGHT;
  }
  return _constants.CSS_MOBILE_HEIGHT;
};
exports.getMobileCssHeightVariable = getMobileCssHeightVariable;
const getSearchInputTopAttribute = ({
  isTopBannerVisible,
  showSearchOnScroll
}) => {
  if (isTopBannerVisible && showSearchOnScroll) {
    return `calc(${_constants.CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT} - ${_constants.SEARCH_INPUT_HEIGHT}px)`;
  }
  if (showSearchOnScroll) {
    return `calc(${_constants.CSS_MOBILE_WITH_SEARCH_INPUT_HEIGHT} - ${_constants.SEARCH_INPUT_HEIGHT}px)`;
  }
  if (isTopBannerVisible) {
    return _constants.CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  return _constants.CSS_MOBILE_HEIGHT;
};
exports.getSearchInputTopAttribute = getSearchInputTopAttribute;
//# sourceMappingURL=getMobileCssVariable.js.map